import { render, staticRenderFns } from "./CreateUnion.vue?vue&type=template&id=75e63e0e&"
import script from "./CreateUnion.vue?vue&type=script&lang=js&"
export * from "./CreateUnion.vue?vue&type=script&lang=js&"
import style0 from "./CreateUnion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports